import { render, staticRenderFns } from "./authdropdown2.vue?vue&type=template&id=3de2fd84&"
import script from "./authdropdown2.vue?vue&type=script&lang=js&"
export * from "./authdropdown2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports